import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './RegisterPage.module.scss';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import SideBanner from '../../components/side-banner/SideBanner';
import { registerActions } from '../../../../stores/_actions';
import contry from 'assets/images/kuwait-flag.png';
import { Copyright } from '../../components/copyright/copyright';
import Label from '../../../../constants/Label';
import Validator from '../../../common/common-functions';
import { TermConditionPage } from '../term-condition/TermConditionPage';

function RegisterPage() {
  const history = useHistory();
  const location = useLocation();
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const registervalue = JSON.parse(localStorage.getItem('registervalue'));
  const [checkedData, setChecked] = React.useState(false);
  const termValue = localStorage.getItem('term');
  localStorage.removeItem('iskycenabled');
  // localStorage.removeItem('customer');
  localStorage.removeItem('CustomerCode');
  localStorage.removeItem('user');
  if (termValue == false || termValue === 'false' || termValue === null) {
    localStorage.removeItem('registervalue');
  }
  useEffect(() => {
    // sessionId ? history.push('/home') : history.push('/');
    if (!termValue) {
      setChecked((checkedData) => (checkedData = false));
    } else {
      setChecked((checkedData) => (checkedData = true));
    }
  }, []);

  const dispatch = useDispatch();
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: '',
    Data: {
      DeviceID: '',
      DeviceType: 'WEB',
      IDNO: '',
      MobileNo: '',
    },
    Status: false,
    SessionID: null,
    IdType: null,
    FileType: null,
    Langcode: '0001',
  };
  const [user, setUser] = useState({
    IDNO: registervalue?.IDNO,
    MobileNo: registervalue?.MobileNo,
  });

  const [submitted, setSubmitted] = useState(false);
  const registering = useSelector((state) => state.registration);
  const [loader, setloader] = useState({
    loader: registering.registration,
  });

  let errorMsg = '';
  let errorMsgIdno = '';
  const handleChange = (e) => {
    setUser((user) => ({ ...user, errorMsg: '' }));
    const { name, value } = e.target;
    if (name == 'MobileNo') {
      setUser((user) => ({ ...user, errorMsg: '' }));
      const checkNumber = Validator.digitsOnly(value);
      if (!checkNumber && value) {
        errorMsg = 'Mobile Number should be Numeric';
        setUser((user) => ({ ...user, [name]: value }));
        setUser((user) => ({ ...user, errorMsg: errorMsg }));
        return;
      }
      if (value.length > 8) return;
      user.prevMobNo = value;
      user.MobileNo = value;
      setUser((user) => ({ ...user, [name]: value }));
    }

    if (name == 'IDNO') {
      setUser((user) => ({ ...user, errorMsgIdno: '' }));
      if (!value) {
        setUser((user) => ({ ...user, [name]: value, errorMsgIdno: 'Please enter KUWAIT CIVIL ID Number' }));
        return;
      }
      const checkNumber = Validator.digitsOnly(value);
      if (!checkNumber) {
        errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
        setUser((user) => ({ ...user, [name]: value }));
        setUser((user) => ({ ...user, errorMsgIdno: errorMsgIdno }));
        return;
      }

      user.prevIDNo = value;
      user.IDNO = value;
      setUser((user) => ({ ...user, [name]: value, errorMsg: '' }));
    }
    setUser((user) => ({ ...user, [name]: value }));
  };
  let errorMsg1 = '';

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    let error = false;
    const checkNumber = Validator.digitsOnly(user.MobileNo);
    if (!user.MobileNo) {
      setUser((user) => ({ ...user, errorMsg: 'Please enter Mobile Number' }));
      error = true;
    } else if (!checkNumber) {
      errorMsg = 'Mobile Number should be Numeric';
      setUser((user) => ({ ...user, errorMsg: errorMsg }));
      error = true;
    } else if (user.MobileNo.length < 8) {
      setUser((user) => ({ ...user, errorMsg: 'Please enter 8 digit valid Mobile Number' }));
      error = true;
    }
    const checkIDNumber = Validator.digitsOnly(user.IDNO);
    if (!user.IDNO) {
      setUser((user) => ({ ...user, errorMsgIdno: 'Please enter KUWAIT CIVIL ID Number' }));
      error = true;
    } else if (!checkIDNumber) {
      errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
      setUser((user) => ({ ...user, errorMsgIdno: errorMsgIdno }));
      error = true;
    } else if (user.IDNO.length < 12) {
      setUser((user) => ({ ...user, errorMsgIdno: 'Please enter 12 digit valid KUWAIT CIVIL ID Number' }));
      error = true;
    }
    if (!document.getElementById('register').checked) {
      errorMsg1 = 'Please agree to the terms & conditions ';
      setUser((user) => ({ ...user, errorMsg1: errorMsg1 }));
      error = true;
    }
    if (error) {
      return;
    }
    if (user.MobileNo && user.IDNO) {
      payload.Data['IDNO'] = user.IDNO;
      payload.Data['MobileNo'] = Label.Register.mobileCountryCode + user.MobileNo;
      payload.Data['DeviceID'] = user.IDNO;
      setloader((loader) => (loader = true));
      dispatch(registerActions.register(payload));
    }
  };

  const TermConditionAction = () => {
    localStorage.setItem('registervalue', JSON.stringify(user));
    history.push('/term-and-condition');
  };

  return (
    <LoadingIndicator>
      {/* isActive={loader.loader == undefined ? false : loader} */}
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.Register.heading}</h1>
          <form name="register" onSubmit={handleSubmit} autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.Register.mobileNumber}</label>
              <input
                type="text"
                name="MobileNo"
                autoComplete="off"
                maxLength="8"
                value={user.MobileNo}
                onChange={handleChange}
                className={styles.contrycode}
              />
              <div className={styles.formgroup__error}>{user.errorMsg}</div>
              <div className={styles.dropdown}>
                <button type="button">
                  <img src={contry} />+{Label.Register.mobileCountryCode}
                </button>
                <div className={styles.dropdown__droppop}>
                  <a href="#">item</a>
                </div>
              </div>
            </div>
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.Register.qatarIdNumber}</label>
              <input type="text" name="IDNO" autoComplete="off" value={user.IDNO} maxLength="12" onChange={handleChange} />
              <div className={styles.formgroup__error}>{user.errorMsgIdno}</div>
              {/* {submitted && !user.IDNO && <div className={styles.formgroup__error}>Please enter KUWAIT CIVIL ID</div>} */}
            </div>
            <input type="submit" value={Label.Register.buttonLabel} className={styles.LoginPage__link} />
            {submitted &&
            registering.data?.statusCode !== '201' &&
            registering.data?.statusCode !== '200' &&
            registering.data?.statusCode !== '404' &&
            registering.data?.statusCode !== '405' ? (
              <div className={styles.formgroup__error}>{<h5>{registering.data?.message}</h5>}</div>
            ) : (
              ''
            )}
          </form>
          <p className={styles.LoginPage__alrmember}>
            Already Registered? <Link to="/">Login!</Link>
          </p>
          <span className={styles.LoginPage__seprator}></span>
          <div className={styles.checkbox}>
            <input
              type="checkbox"
              id="register"
              name="register"
              value={user.register}
              checked={checkedData}
              onChange={() => setChecked(!checkedData)}
            />
            <label htmlFor="register">
              I have read and accept the <a onClick={TermConditionAction}>Terms & Conditions.</a>
            </label>
            {/* <Link to="/term-and-condition">Terms & Conditions.</Link> */}
          </div>
          {!checkedData ? <div className={styles.formgroup__error}>{user.errorMsg1}</div> : ''}
          <Copyright />
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { RegisterPage };
